import { VisualizatorSettings } from "./visualizator-settings";
import { ObjectCreator } from "../../../../../web-graphics";

export class UnitSettings extends VisualizatorSettings {
  constructor(settings) {
    super(settings);
    const unitFields = ["id", "text", "scale"];
    for (const key of Object.getOwnPropertyNames(settings)) {
      if (unitFields.includes(key)) {
        this[key] = settings[key];
      } else {
        if (typeof settings[key] === "object" && settings[key].copy !== undefined) {
          this[key] = settings[key].copy();
        } else if (typeof settings[key] !== "function") {
          this[key] = ObjectCreator.deepCopy(settings[key]);
        }
      }
    }
  }

  copy() {
    return new UnitSettings(this);
  }
}
